import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/Page.css';

const CareersPage = () => {
  return (
   
      <div className="page-content">
        <h1>Careers</h1>
        <div className="no-openings-message">
          <h3>No current openings</h3>
          <p>Check back later for opportunities.</p>
          <p>Email: <a href="mailto:careers@aspenquickcare.com">careers@aspenquickcare.com</a></p>
          <Link to="/" className="back-home">
            ← Back to Home
          </Link>
        </div>
      </div>
    
  );
};

export default CareersPage;
